import React, { useEffect, createElement } from 'react';
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { SocialProofSection } from './components/SocialProofSection';
import { ProblemSection } from './components/ProblemSection';
import { TransitionSection } from './components/TransitionSection';
import { ProductSection } from './components/ProductSection';
import { IncludedSection } from './components/IncludedSection';
import { BonusSection } from './components/BonusSection';
import { UrgencySection } from './components/UrgencySection';
import { OfferSection } from './components/OfferSection';
import { TrustBar } from './components/TrustBar';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { PurchasePopup } from './components/PurchasePopup';
import { CountdownTimer } from './components/CountdownTimer';
export function App() {
  useEffect(() => {
    // Meta Pixel Integration
    const initPixel = () => {
      const f = window as any;
      if (f.fbq) return;
      const n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = !0;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      }
      f.fbq('init', '1322033292727002');
      f.fbq('track', 'PageView');
    };
    initPixel();
  }, []);
  return <div className="min-h-screen bg-dark text-white font-inter selection:bg-primary selection:text-dark" data-id="element-0">
      <StickyBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <SocialProofSection data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <TransitionSection data-id="element-6" />
        <ProductSection data-id="element-7" />
        <IncludedSection data-id="element-8" />
        <BonusSection data-id="element-9" />
        <UrgencySection data-id="element-10" />
        <OfferSection data-id="element-11" />
        <TrustBar data-id="element-12" />
        <TestimonialsSection data-id="element-13" />
        <GuaranteeSection data-id="element-14" />
        <FAQSection data-id="element-15" />

        {/* Final CTA Section */}
        <section className="py-20 px-4 bg-dark-light text-center border-t border-white/10" data-id="element-16">
          <div className="max-w-3xl mx-auto" data-id="element-17">
            <h2 className="text-3xl md:text-4xl font-bold mb-8 text-white" data-id="element-18">
              Ahora es tu turno.
            </h2>
            <p className="text-xl text-gray-300 mb-8" data-id="element-19">
              Accedé ahora mismo y empezá a preparar más de 100 recetas
              irresistibles en minutos.
            </p>

            <div className="flex justify-center mb-8" data-id="element-20">
              <CountdownTimer variant="inline" data-id="element-21" />
            </div>

            <a href="http://checkout.sabores365.online/cart/58343606157393:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto bg-primary hover:bg-primary-hover text-dark font-bold text-xl md:text-2xl py-6 px-12 rounded-xl shadow-[0_0_30px_rgba(245,183,49,0.4)] hover:shadow-[0_0_50px_rgba(245,183,49,0.6)] transition-all duration-300 hover:scale-105" data-id="element-22">
              OBTENER MI PACK COMPLETO
            </a>
          </div>
        </section>
      </main>

      <PurchasePopup data-id="element-23" />
    </div>;
}